var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { footer } from '../utils/theme';
import { emailDomainLabel, emailDomainType } from '../utils/misc';
import { registerClass, subClass, classNames, currySC, } from '@food/css-manager';
import { Button } from '@food/ui/build/dist/src/Button';
var style = registerClass(function (theme, sc) { return "\n\t." + sc('value') + " {\n\t\tfont-weight: " + theme.font.weights.bold + ";\n\t}\n\t\n\t." + sc('spaced-top') + " {\n\t\tmargin-top: " + theme.ratios.l * theme.font.baseSize + "px;\n\t}\n\t\n\t." + sc('spaced-bottom') + " {\n\t\tmargin-bottom: " + theme.ratios.l * theme.font.baseSize + "px;\n\t}\n"; });
var sc = currySC(style);
var valueClass = sc('value');
export var Success = function (_a) {
    var t = _a.t, user = _a.user, managed = _a.managed, isModal = _a.isModal, proceed = _a.proceed, supportEmail = _a.supportEmail;
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", null, t(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Hello"], ["Hello"]))),
            " ",
            user.firstName,
            " ",
            user.lastName,
            "!"),
        React.createElement("section", { className: style },
            React.createElement("div", { className: sc('spaced-bottom') }, t(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Thanks for validating"], ["Thanks for validating"]))),
                "."),
            React.createElement("div", null, t(templateObject_3 || (templateObject_3 = __makeTemplateObject(["You have been successfully registered as a"], ["You have been successfully registered as a"]))),
                ":",
                ' ',
                React.createElement("span", { className: valueClass }, t(user.role)),
                React.createElement("br", null),
                managed && (React.createElement(React.Fragment, null, t(templateObject_4 || (templateObject_4 = __makeTemplateObject(["as we related you to"], ["as we related you to"]))),
                    ":",
                    ' ',
                    React.createElement("span", { className: valueClass },
                        emailDomainLabel(managed),
                        managed.CountryName && ' - ' + emailDomainType(managed))))),
            React.createElement("div", { className: sc('spaced-top') }, t(templateObject_5 || (templateObject_5 = __makeTemplateObject(["If you think we're wrong please"], ["If you think we're wrong please"]))),
                ' ',
                React.createElement("a", { href: "mailto:" + supportEmail }, t(templateObject_6 || (templateObject_6 = __makeTemplateObject(["contact us"], ["contact us"]))))),
            React.createElement("div", { className: classNames(footer, subClass(footer, 'centered')) },
                React.createElement(Button, { label: t(isModal ? 'Close' : 'Proceed'), onClick: proceed })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Success.js.map